import React from 'react';
import GitHubIcon from '@mui/icons-material/GitHub';

const Footer = () => {
  return (
    <div>
      <footer class="d-flex flex-wrap justify-content-between align-items-center py-3 my-4 border-top">
        <div class="col-md-4 d-flex align-items-center">
          <a href="/" class="mb-3 me-2 mb-md-0 text-muted text-decoration-none lh-1">
            <svg class="bi" width="30" height="24"></svg>
          </a>
          <span class="text-muted">© 2023 Blog📲 , Meet007</span>
        </div>

        <ul class="nav col-md-4 justify-content-end list-unstyled d-flex mx-5">
          <li class="ms-3"><a class="text-muted" href="https://github.com/MeetDOD"><svg class="bi" width="24" height="24"><GitHubIcon /></svg></a></li>
        </ul>
      </footer>
    </div>
  )
}

export default Footer
